import { Injectable, inject } from '@angular/core';

import { Globals } from '@core/globals';
import { FilterParams } from '@models/filter.model';
import { FilterDataMessage } from '@models/filter-data.model';

@Injectable({
  providedIn: 'root',
})
export class ListUrlService {
  private globals = inject(Globals);

  generateUrl(data: FilterParams, filter: FilterDataMessage): { url: string; fragment?: string } {
    const urlParams: string[] = [];
    let params: { [key: string]: string } = {};

    for (let key in data) {
      const item = data[key as keyof FilterParams];
      if (item === undefined || item === null) continue;
      if (key === 'makeModelId') {
        const makesObject = item as FilterParams['makeModelId'];
        if (makesObject?.length === 0) continue;
        const makes: number[] = [];
        const models: { [key: string]: string } = {};
        if (!makesObject) continue;
        for (let make of makesObject) {
          if (!makes.includes(make.makeId)) makes.push(make.makeId);
          if (make.modelId.length) models['models-' + make.makeId] = make.modelId.join('-');
        }
        params['makes'] = makes.join('-');
        params = { ...params, ...models };
      } else {
        if (Array.isArray(item)) {
          params[key + '-array'] = item.join('-');
        } else {
          params[key] = item.toString();
        }
      }
    }

    const listUrl: string = this.globals.routes()['list'].url;
    urlParams.push(listUrl);
    const makeModel: FilterParams['makeModelId'] = data.makeModelId;
    if (makeModel?.length === 1) {
      delete params['makes'];
      const findMake = filter.make.find((item) => item.id === makeModel[0].makeId);
      if (findMake) {
        urlParams.push(findMake.slug);
        if (makeModel[0].modelId.length === 0) {
          delete params['models-' + makeModel[0].makeId];
        } else if (makeModel[0].modelId.length === 1) {
          delete params['models-' + makeModel[0].makeId];
          urlParams.push(filter.make.find((item) => item.id === makeModel[0].makeId)!.model.find((item) => item.id === makeModel[0].modelId[0])!.slug);
        }
      }
    }
    const bodyType: FilterParams['bodyTypeId'] = data.bodyTypeId;
    if (bodyType?.length === 1) {
      delete params['bodyTypeId-array'];
      urlParams.push(filter.bodyType.find((item) => item.id === bodyType[0])!.slug);
    }
    const fuelType: FilterParams['fuelTypeId'] = data.fuelTypeId;
    if (fuelType?.length === 1) {
      delete params['fuelTypeId-array'];
      urlParams.push(filter.fuelType.find((item) => item.id === fuelType[0])!.slug);
    }
    const gearbox: FilterParams['gearboxId'] = data.gearboxId;
    if (gearbox?.length === 1) {
      delete params['gearboxId-array'];
      urlParams.push(filter.gearbox.find((item) => item.id === gearbox[0])!.slug);
    }
    if (data.yearFrom) {
      urlParams.push(data.yearFrom.toString());
      delete params['yearFrom'];
    }

    const queryString: string = Object.keys(params)
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join('&');
    return { url: urlParams.join('/'), fragment: queryString === '' ? undefined : queryString };
  }
}
